import { useEffect, useState } from "react";

const useFetch = (url) => {
  const [data, setData] = useState();
  const [isPending, setIsPending] = useState(true);
  const [serverError, setServerError] = useState();
  useEffect(() => {
    const fetchApi = async () => {
      await fetch(url, {
        method: "GET", // or 'POST', 'PUT', etc.
        headers: {
          "Accept-Encoding": "gzip, deflate, brotli, compress, br",
          // 'Content-Encoding': 'br'
          // Add other headers as needed
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          setData(data);
          setIsPending(false);
          setServerError(false);
        })
        .catch((error) => {
          setServerError(error.message);
          setIsPending(false);
        });
    };
    fetchApi();
  }, [url]);

  return { data, isPending, serverError };
};

export default useFetch;
